import React, { type FC } from 'react'
import { InitialData } from '@mobi/api-types'
import { type PayIdDetails } from '@mobi/api-types/src/account/betAccount'
import type { PaymentMethodsSelfServe } from '@mobi/component-library/Areas/Deposit/types'
import { PanelStyled } from './DepositBody.styles'
import { BPayPanel, CashPanel, PayIDPanel, ScanMyBetPanel } from './Payments'
import type { PanelProps } from './types'

type Props = {
  accountNumber: number
  paymentMethod: PaymentMethodsSelfServe
  initialData: InitialData
  isPreCommitmentLimitSet: boolean
  payIdDetailList: PayIdDetails[]
  remainingDepositAmount: number
  remainingDepositTransactions: number
}

export const SelfServeDepositPanels: FC<Props> = ({
  accountNumber,
  paymentMethod,
  initialData,
  isPreCommitmentLimitSet,
  payIdDetailList,
  remainingDepositAmount,
  remainingDepositTransactions,
}) => {
  const Panel = externalPaymentPanels[paymentMethod]
  return (
    <PanelStyled>
      <Panel
        accountNumber={accountNumber}
        initialData={initialData}
        isPreCommitmentLimitSet={isPreCommitmentLimitSet}
        payIdDetailList={payIdDetailList}
        depositLimits={initialData.depositLimits}
        remainingDepositAmount={remainingDepositAmount}
        remainingDepositTransactions={remainingDepositTransactions}
      />
    </PanelStyled>
  )
}

const externalPaymentPanels: Record<
  PaymentMethodsSelfServe,
  React.FC<
    Pick<PanelProps, 'accountNumber' | 'initialData'> & {
      isPreCommitmentLimitSet: boolean
      payIdDetailList: PayIdDetails[]
      depositLimits: { minimum: number; maximum: number }
      remainingDepositAmount: number
      remainingDepositTransactions: number
    }
  >
> = {
  BPay: BPayPanel,
  Cash: CashPanel,
  ScanMyBet: ScanMyBetPanel,
  PayID: PayIDPanel,
} as const
